"use client";

import { useTheme } from "next-themes";
import { useEffect } from "react";

const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

const persistThemeCookie = (value: string) => {
  // biome-ignore lint/suspicious/noDocumentCookie: Persist theme cookie so the server can render with the same palette
  document.cookie = `theme=${value}; path=/; max-age=${ONE_YEAR_IN_SECONDS}; samesite=lax`;
};

export function ThemeSync() {
  const { theme } = useTheme();

  useEffect(() => {
    // Sync theme to cookie whenever it changes
    if (theme) {
      persistThemeCookie(theme);
    }
  }, [theme]);

  // Also sync on mount to ensure cookie is set
  useEffect(() => {
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) {
      persistThemeCookie(storedTheme);
    }
  }, []);

  return null;
}
